export default __webpack_public_path__ + "static/media/D-DIN.31d45669.otf";